import { render, staticRenderFns } from "./ResultsPagination.vue?vue&type=template&id=5e8e3f01&scoped=true&"
import script from "./ResultsPagination.vue?vue&type=script&lang=js&"
export * from "./ResultsPagination.vue?vue&type=script&lang=js&"
import style0 from "./ResultsPagination.vue?vue&type=style&index=0&id=5e8e3f01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8e3f01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VPagination,VRow})
